'use client';

import {
  Company,
  Image,
  Office,
  UseRowsReturn,
} from '@nettbureau/featured-core';
import { ContactCard } from '../card/ContactCard';
import { Featured } from '../featured/Featured';

interface CompaniesSectionProps {
  companies: UseRowsReturn<Company | Office>;
  title: string;
  contactUrl: string | null;
  defaultBackground: Image | null;
}

export function CompaniesSection({
  companies,
  title,
  defaultBackground,
  contactUrl,
}: CompaniesSectionProps) {
  {
    return companies ? (
      <Featured<Company | Office>
        rows={companies}
        showButton={companies.rows.filter((row) => !row.visible).length > 0}
        title={title}
        contactUrl={contactUrl}
        cardRenderer={(attributes, index) => {
          return (
            <ContactCard
              id={attributes.id}
              key={index}
              subTitle={null}
              subscriptionLevel={attributes.subscriptionLevel}
              title={attributes.name}
              center={null}
              bodyLine1={attributes.address}
              bodyLine2={`${attributes.postcode ?? ''} ${attributes.postarea ?? ''}`}
              icon={attributes.icon}
              background={attributes.background ?? defaultBackground}
              logo={attributes.logo}
              website={attributes.website}
              phone={attributes.phone}
              email={attributes.email}
              href={attributes.internalLink ?? null}
            />
          );
        }}
      />
    ) : null;
  }
}
